import omit from 'lodash-es/omit'

import { GeoFence, GeofenceCreateUpdatePayload } from '@/feature/observatory/types/GeoFence.types'

import { request } from '@/lib/utils/request'

export const createGeoFence = async (geoFence: GeofenceCreateUpdatePayload): Promise<GeoFence> => {
  const response = await request.post<GeoFence>('v1/geofences/', geoFence)
  return response.data
}

export const editGeoFence = async (
  geoFenceId: GeoFence['id'],
  geoFence: GeofenceCreateUpdatePayload,
): Promise<GeoFence> => {
  const response = await request.patch<GeoFence>(
    `v1/geofences/${geoFenceId}/`,
    omit(geoFence, ['id', 'organisation']),
  )
  return response.data
}

export const deleteGeoFence = async (geoFenceId: GeoFence['id']): Promise<GeoFence> => {
  const response = await request.delete<GeoFence>(`v1/geofences/${geoFenceId}/`)
  return response.data
}
